import React from 'react';
import { Button, Card } from '@hz-design-system/web-ui';

import Skeleton from '../Skeleton/index';

import ComponentClasses from './SearchPreview.module.scss';

const SearchPreviewSkeleton = () => (
  <Card className={ComponentClasses.root}>
    <div className={ComponentClasses.header}>
      <Skeleton.Text type="short" withAnimation={true} />
    </div>
    <div className={ComponentClasses.previewImages}>
      <Skeleton.Block className={ComponentClasses.imageWrapper} withAnimation={true} />
      <Skeleton.Block className={ComponentClasses.imageWrapper} withAnimation={true} />
      <Skeleton.Block className={ComponentClasses.imageWrapper} withAnimation={true} />
      <Skeleton.Block className={ComponentClasses.imageWrapper} withAnimation={true} />
    </div>
    <Button.Tertiary className={ComponentClasses.button}>
      <Skeleton.Text type="short" withAnimation={true} />
    </Button.Tertiary>
  </Card>
);

export default SearchPreviewSkeleton;
